<template>
    <div class="header-container">
        <div class="header">
            <!--            <router-link to="/home">-->
            <!--                <div class="flex align-center" v-if="logo.morglogo">-->
            <!--                    <img :src="logo.morglogo" alt="" class="logo" />-->
            <!--                    <div class="title">{{logo.morgname}}会员管理系统</div>-->
            <!--                </div>-->
            <!--                <img src="../assets/img/logo_emof.png" alt="" class="logo_zc" v-else/>-->
            <!--            </router-link>-->
            <a :href="`${IMAGE_PATH}`">
                <div class="flex align-center" v-if="logo.morglogo">
                    <img :src="logo.morglogo" alt="" class="logo"  v-if="logo.morgname"/>
                    <img :src="logo.morglogo" alt="" class="logo_zc" v-else/>
                    <div class="title" v-if="logo.morgname">{{ logo.morgname }}</div>
                </div>
                <img src="../assets/img/logo_emof.png" alt="" class="logo_zc" v-else/>
            </a>
            <div class="home flex align-center">
                <div class="service">
                    <i class="iconfont icon-kefu margin-right-xs font-size-lg"></i>客服电话：{{ service_phone }}
                </div>
                <a :href="url" class="operate" v-if="url">{{ back }}</a>
                <div  class="operate" v-else @click="$router.go(-1)">{{ back }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {service_phone} from "@/utils/const";
import {IMAGE_PATH} from "@/config";

export default {
    components: {},
    name: "headers",
    data() {
        return {
            IMAGE_PATH: IMAGE_PATH,
            service_phone: service_phone
        }
    },
    props: {
        url: {
            type: String,
            default: '/home'
        },
        back: {
            type: String,
            default: '返回知诚会首页'
        },
        logo: {
            type: [String,Object],
            default: () => {
                return {
                    morglogo: '',
                    morgname: '',
                }
            }
        },
    },
    computed: {},
    created() {

    },
    methods: {}
}
</script>

<style scoped lang="scss">
.header-container {
    background-color: #0a2240;
    box-shadow: 0px 6px 18px 1px rgba(10, 34, 64, 0.45);
    width: 100%;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        height: 100px;
        margin: 0 auto;

        .logo_zc {
            height: 42px;
        }

        .logo {
            height: 49px;
            width: 49px;
            border-radius: 49px;
        }

        .title {
            font-size: 24px;
            font-weight: 600;
            margin-left: 12px;
            color: #FFFFFF;
            //color: transparent;
            //line-height: 24px;
            //-webkit-background-clip: text;
            //background-image: linear-gradient(0deg,
            //    #ed6e16 0%,
            //    #ffffff 100%);
            //background-blend-mode: normal, normal;
        }

        .home {
            .service {
                font-size: 18px;
                color: #f5f5f5;
                margin-right: 20px;
            }

            .operate {
                padding: 0 20px;
                height: 40px;
                background-color: #ff9600;
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                user-select: none;
            }
        }
    }
}
</style>